<div class="row" *ngIf="(tableItem | json) != '{}'">
    <div class="col-sm-12">
        <div class="row">
            <div class="col">
                <label class="fw-bold">ID</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.groupId" disabled />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">ERP Group ID</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.erpGroupId" required />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Name</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.name" required [disabled]="tableItem.groupId > 0" />
            </div>
        </div>
        <div class="row">
            <div class="col m-2 text-end">
                <button class="btn btn-primary m-2" (click)="save()">Save</button>
                <button class="btn btn-secondary m-2" (click)="cancel()">Cancel</button>
            </div>
        </div>
    </div>
</div>
